
export default [
  {
    name: 'SiteCodeUpload',
    path: '/site-code-upload',
    component: () =>
      import(
        /* webpackChunkName: "SiteCodeUpload" */ '@/views/site-code-upload'
      ),
    meta: { title: '拍照上传场所码' },
  },
];
